





import Vue from 'vue'
import Mailing from '@/models/mailing/mailing'
import filtersList from '@/components/Newsletters-stuff/filtersList.vue'

export default Vue.extend({
  name: 'RecipientsIndexColumn',
  props: {
    row: Object as () => Mailing
  },
  components: {
    filtersList
  }
})
